export function stickyBlock() {

    function sticky() {

        if (window.innerWidth >= 1000) {

            let stickyContainer = document.querySelectorAll('[am-sticky="container"]');

            stickyContainer.forEach( function(block) {
                window.addEventListener('scroll', function() {

                    let fixidHeight = document.querySelector('[am-fixed]').clientHeight,
                        top = block.getBoundingClientRect().top - fixidHeight,
                        blockPaddingTop = window.getComputedStyle(block, null).paddingTop,
                        blockPaddingBottom = window.getComputedStyle(block, null).paddingBottom,
                        blockRealHeight = block.clientHeight - parseInt(blockPaddingTop) - parseInt(blockPaddingBottom),
                        item = block.querySelector('[am-sticky="block"]');

                    if (top < 0) {
                        let itemMarginTop = window.getComputedStyle(item, null).marginTop;

                        item.classList.add('is-active');
                        if (item.scrollHeight  +  - top < blockRealHeight) {
                            item.style.top = - top  + 'px';
                        } else {
                            item.style.top = blockRealHeight-item.clientHeight-parseInt(itemMarginTop) + 'px';
                        }
                    } else {
                        item.classList.remove('is-active');
                        item.style.top = '0px';
                    }

                });
            });
        };
    };

    sticky();
    window.addEventListener('resize', sticky);
    window.addEventListener('orientationchange', sticky);
}
